import {
  GET_MEMBERSHIPS_LIST_BEGINS,
  GET_MEMBERSHIPS_LIST_SUCCESS,
  GET_MEMBERSHIPS_LIST_FAILURE,
  ADD_MEMBERSHIP_BEGINS,
  ADD_MEMBERSHIP_SUCCESS,
  ADD_MEMBERSHIP_FAILURE,
  UPDATE_MEMBERSHIP_TIER_BEGINS,
  UPDATE_MEMBERSHIP_TIER_SUCCESS,
  UPDATE_MEMBERSHIP_TIER_FAILURE,
  GET_MEMBERSHIPS_PAGINATION_SUCCESS,
  GET_MEMBERSHIPS_SEARCH_SUCCESS,
} from "../constants";

const INITIAL_STATE = {
  isTableLoading: false,
  memberships: {
    data: [],
    total: 0,
  },
  membershipSearch: "",
  membershipPagination: 0,
  loading: false,
  error: null,
};

const membershipsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_MEMBERSHIPS_LIST_BEGINS:
      return { ...state, isTableLoading: true };
    case GET_MEMBERSHIPS_LIST_SUCCESS:
      return { ...state, isTableLoading: false, memberships: action.data?.response || state.memberships };
    case GET_MEMBERSHIPS_LIST_FAILURE:
      return { ...state, isTableLoading: false };

    case ADD_MEMBERSHIP_BEGINS:
      return { ...state, loading: true };
    case ADD_MEMBERSHIP_SUCCESS:
      return { ...state, loading: false };
    case ADD_MEMBERSHIP_FAILURE:
      return { ...state, loading: false };

    case UPDATE_MEMBERSHIP_TIER_BEGINS:
      return { ...state, loading: true };
    case UPDATE_MEMBERSHIP_TIER_SUCCESS:
      return { ...state, loading: false };
    case UPDATE_MEMBERSHIP_TIER_FAILURE:
      return { ...state, loading: false };

    case GET_MEMBERSHIPS_PAGINATION_SUCCESS:
      return { ...state, membershipPagination: action.data };

    case GET_MEMBERSHIPS_SEARCH_SUCCESS:
      return { ...state, membershipSearch: action.data };

    default:
      return state;
  }
};

export default membershipsReducer;
